<template>
  <div class="flex min-h-screen flex-col">
    <MenuMainMenu />
    <MenuBreadcrumbs />
    <ContainerDefaultWidth class="flex-1"><slot /></ContainerDefaultWidth>
    <FooterSiteFooter :show-tagline="true" />
  </div>
</template>
